import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  tenantId: string;
  actorSub?: string | null;
  action: string;
  entity: string;
  occurredAt: string;
};

export default function PlatformAuditPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ entries: Row[] }>(
    "/api/v1/tenant/platform/audit-log",
  );
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("platform.audit.title")}</h1>
      <DataTable
        rows={data?.entries ?? null}
        loading={loading}
        error={error}
        empty={t("platform.audit.empty")}
        columns={[
          { header: "Tenant", render: (r) => r.tenantId },
          { header: t("audit.actor"), render: (r) => r.actorSub ?? "—" },
          { header: t("audit.action"), render: (r) => r.action },
          { header: t("audit.entity"), render: (r) => r.entity },
          {
            header: t("audit.timestamp"),
            render: (r) => new Date(r.occurredAt).toLocaleString(),
          },
        ]}
      />
    </div>
  );
}
